import type { ReactNode } from "react"
import useLocalStorage from "@/v2-ui/utils/utils.localStorage"
import { SidebarContext } from "@/v2-backoffice-client/components/sidebar/sidebar.context"

export type SidebarProviderProps = {
  children: ReactNode
}

function SidebarProvider(props: SidebarProviderProps) {
  const isMiniStorage = useLocalStorage("sidebar-isMini", false)
  const isMini = isMiniStorage.value ?? false
  return (
    <SidebarContext.Provider
      value={{ isMini: isMini ?? false, setIsMini: isMiniStorage.setItem }}
      {...props}
    />
  )
}

export default SidebarProvider
